import * as React from 'react';
import { useEffect } from 'react';
import Top from "../Top";
import Bottom from "../Bottom";
import GaugeComponent from 'react-gauge-component'
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import MoodIcon from '@mui/icons-material/Mood';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import SentimentNeutralIcon from '@mui/icons-material/SentimentNeutral';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import MoodBadIcon from '@mui/icons-material/MoodBad';
import Button from '@mui/material/Button';
import { useLocation, useNavigate } from "react-router-dom";
import { selfQuestionnaires } from "../../utils/selfQuestionnaires";

import CheckMain from "./CheckMain";
import StateMissingFallback from "../../components/StateMissingFallback";

const SelfScore = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { selfQuestionNo, selfQuestionOriginalPoint, selfQuestionTypePoint } = state ?? {};
  const [resultTypeIndex, setResultTypeIndex] = React.useState(0);

  useEffect(() => {
    // early return 과 달리 effect 는 실행되므로 여기서도 막는다
    if (!state) return;
    setResultTypeIndex(selfQuestionnaires.filter((v: any) => v.no === selfQuestionNo)[0].subArcs.findIndex((v: any) => v.limit >= selfQuestionOriginalPoint));

    return () => {
    }
  }, []);

  function getResultIconTypeComponent(type: any) {
    if (type === 'MoodIcon') {
      return <MoodIcon sx={{ fontSize: 60, color: '#47D9D9' }} />;
    } else if (type === 'SentimentSatisfiedAltIcon') {
      return <SentimentSatisfiedAltIcon sx={{ fontSize: 60, color: '#8AB904' }} />;
    } else if (type === 'SentimentNeutralIcon') {
      return <SentimentNeutralIcon sx={{ fontSize: 60, color: '#FFBB00' }} />;
    } else if (type === 'SentimentVeryDissatisfiedIcon') {
      return <SentimentVeryDissatisfiedIcon sx={{ fontSize: 60, color: '#FF8000' }} />;
    } else if (type === 'MoodBadIcon') {
      return <MoodBadIcon sx={{ fontSize: 60, color: '#C80000' }} />;
    }
  }



  // state 없이 진입하면(새로고침·직접 URL 접근) 렌더할 데이터가 없다.
  // 아래에서 undefined 의 속성을 읽어 화면이 깨지므로 렌더하지 않는다.
  // state 가 없으면 백지 대신 빠져나갈 수 있는 안내를 보여준다
  if (!state) {
    return (
      <StateMissingFallback
        title="자가진단 결과"
        message={'결과 정보를 불러오지 못했습니다.\n자가진단을 다시 진행해 주세요.'}
        actionLabel="자가진단 목록으로"
        to="/check/SelfCheckList"
      />
    );
  }

  return (

    <Container sx={{ width: '100%', minWidth: 320,  background: '#F1F2F4', p: 0, pb: 8, boxSizing: 'border-box' }} >
      <Top title="자가진단 결과" />
      <Box sx={{ pl: 2, pr: 2, }}>
        <Box sx={{ p: 2, pt: 8, mt: 2 }}>
          <Typography component="div" sx={{ fontSize: 20, color: '#555', textAlign: 'center', fontWeight: 700, mb: .5 }}>
            {selfQuestionnaires && selfQuestionnaires.filter((v: any) => v.no === selfQuestionNo)[0].title}
          </Typography>
          <Typography component="div" sx={{ fontSize: 16, color: '#777', textAlign: 'center', fontWeight: 700 }}>
            자가진단
          </Typography>
        </Box>

        <Box sx={{ bgcolor: '#fff', p: 2, mt: 1, borderRadius: 4, boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.12)', }}>
          <Typography component="div" sx={{ fontSize: 18, color: '#555', textAlign: 'center', mb: 1, fontWeight:700 }}>
            진단 결과
          </Typography>

          <Box sx={{ mt: -2, pb:2 }}>
            <GaugeComponent
              type="semicircle"
              arc={{
                colorArray: selfQuestionnaires.filter((v: any) => v.no === selfQuestionNo)[0].colorArray,
                padding: 0.02,
                subArcs: selfQuestionnaires.filter((v: any) => v.no === selfQuestionNo)[0].subArcs
              }}
              pointer={{ type: "blob", animationDelay: 0 }}
              value={selfQuestionOriginalPoint}
              maxValue={selfQuestionnaires && selfQuestionnaires.filter((v: any) => v.no === selfQuestionNo)[0].resultMaxPoint}
              labels={{
                valueLabel: {
                  formatTextValue: (value) => selfQuestionOriginalPoint + '점',
                  style: { fontSize: "24px", fill: "#555", textShadow: "0", fontWeight: 700 }
                },
              }}
            />
          </Box>

          <Divider />

          <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} sx={{ mt: 2 }}>
            {getResultIconTypeComponent(selfQuestionnaires.filter((v: any) => v.no === selfQuestionNo)[0].results[resultTypeIndex].resultIconType)}
            <Box sx={{ ml: 2 }}>
              <Typography component="div" sx={{ fontSize: 16, fontWeight: 700, }}>
                {selfQuestionnaires.filter((v: any) => v.no === selfQuestionNo)[0].results[resultTypeIndex].resultTitle}
              </Typography>
              <Typography component="div" sx={{ fontSize: 14, color: '#555', mt: 0.5 }}>
                {selfQuestionnaires.filter((v: any) => v.no === selfQuestionNo)[0].results[resultTypeIndex].resultCondition}
              </Typography>
            </Box>
          </Stack>

        </Box>

        {selfQuestionnaires && selfQuestionnaires.filter((v: any) => v.no === selfQuestionNo)[0].intervention.map((item: any, index: any) => (
          <React.Fragment>
            {index === 0 ? (<Typography sx={{ mt: 4, fontWeight: 700, color: '#555' }}>치료 방법</Typography>) : (null)}
            <Box sx={{ bgcolor: '#fff', p: 2, m: 0, mt: 1, borderRadius: 4, boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.12)', }}>
              <Typography sx={{ fontSize: 14 }}>{item}</Typography>
            </Box>
          </React.Fragment>
        ))}

        <Typography sx={{ mt: 4, fontWeight: 700, color: '#555' }}>진단 결과</Typography>
        <Box sx={{ p: 2, m: 0, mt: 1, borderRadius: 4, boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.12)', bgcolor: '#fff', }}>
          <Stack direction={'column'}>
            {selfQuestionnaires && selfQuestionnaires.filter((v: any) => v.no === selfQuestionNo)[0].results.map((item: any, index: any) => (
              <Stack direction={'row'} alignItems={'center'} sx={{ m: 1 }}>
                {getResultIconTypeComponent(item.resultIconType)}
                <Box sx={{ ml: 2 }}>
                  <Typography sx={{ fontWeight: 700 }}>{item.resultTitle}</Typography>
                  <Typography sx={{ fontSize: 14, color: '#777', mt: 0.5 }}>{item.resultCondition}</Typography>
                </Box>
              </Stack>
            ))}
          </Stack>
        </Box>

        <Box sx={BtnStyle}>
          <Button variant="contained" sx={BottomBtnStyle}
            onClick={() => navigate('../check/SelfCheckList')}
          >
            확인
          </Button>
        </Box>
      </Box>

      <React.Fragment>
        <Box sx={{ bgcolor: '#fff', p: 1, pl: 2, pr: 2, mt: 8 }}>
          <Typography sx={{ fontSize: 16, fontWeight: 700, color: '#555', pt: 1, mb: 1, pl: 2, }}>추천 자가진단 </Typography>
          <CheckMain />
        </Box>
      </React.Fragment>



      <Bottom />
    </Container>
  );
}



const BtnStyle = {
  display: 'flex',
  justifyContent: 'center',
  mt: 7,
};

const BottomBtnStyle = {
  width: '100%',
  bgcolor: '#EF8322',
  fontSize: 18,
  fontWeight: 700,
  borderRadius: '30px',
  boxSizing: 'border-box',
  color: '#fff',
  border: '0px solid #ef8322',
  ':hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color: '#fff'
  },
  ':active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  ':focus': {
    boxShadow: 'none',
  },
};

export default SelfScore;